import React, { useRef } from "react";
import { Footer } from "./Footer";
import Brands from "./Brands";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import { Col, Container, Row, Button } from "react-bootstrap";
import smodab from "../Assets/img/smabout.jpg";
import GoTop from "./GoTop";
import sm from "../Assets/img/alsmood.png";
import bgImage from "../Assets/img/bgs/18.jpeg";
import Navigation from "./Navigation";

const AlSmood = ({ lang: currentLanguage }) => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_inyaa89",
        "template_993qouc",
        form.current,
        "user_DfrMcD1i8Klde4wR1m0qR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();

  };
    const { t } = useTranslation();

 
  const aboutTextClass = () => {
    switch (currentLanguage.code) {
      case 'en':
        return 'about-text-en';
      case 'ar':
        return 'about-text-ar';
      case 'kur':
        return 'about-text-kur';
      default:
        return ''; // Fallback class
    }
  };
  
  const menu = ["about", "alSmood"];
  return (
    <>
      <Navigation navs={menu} />
      <div id="sm-head" >
      {/* Ensure the class is b-bg-container, NOT b-bg */}
     <div className="hero-motion-container">
  {/* Layer 1: Background */}
  <img src={bgImage} className="hero-motion-bg" alt="" />
  
  {/* Layer 2: Content on top */}
  <div className="hero-motion-overlay">
    <img src={sm} className="hero-motion-logo" alt="Logo" />
    <h3 style={{ color: '#000', fontWeight: '700' }}>{t("sm_top_header1")}</h3>
        </div>
      </div>
      </div>
      {/* Brands */}
      <Brands />
      {/* ABOUT */}
                  <div id="about" className="s-about" data-aos="fade-up" data-aos-duration="1000">
              <div className="s-about-inner">
                      <Container>
                        <Row>
                          <Col
                              md={6}
                              className="left d-flex justify-content-center align-items-cenetr"
                             >
                             <div className="text-center">
                            <img src={smodab} className="about-img-brc img-fluid" alt={t("p_type1")} />
                             </div>
                          </Col>
                          <Col xs={12} md={6} className="about-us">
                                          <div className={`about-text ${aboutTextClass()}`}>
                                            <h2 className={` ${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}>
                                              {t("about_us")}
                                            </h2>
                                            <div className="mb-4">
                                              <hr className="hr" />
                                            </div>
                                            <div className={`about-text ${aboutTextClass()}`}>
                                              <p>{t("smabout_p")}</p>
                                            </div>
                                          </div>
                                        </Col>
                        </Row>
                     </Container>
                    </div>
                  </div>
                        
                        <div className="article-text-box" data-aos="fade-up" data-aos-duration="1000">
                                <Container>
                                  <div className="article">
                                    
                                  
                                    
                                    
                                     {/* Our vision*/}
                                     <div className="whatssandwich mb-5" data-aos="fade-in" data-aos-duration="1500">
                                         <Container>
                                                                                <h4
                                                                                  className={`mb-1  ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                                >
                                                                                  {t("sm_vision")}
                                                                                </h4>
                                                                                <div className="mb-3">
                                                                                  <hr className="s-hr" />
                                                                                </div>
                                                                                <div className="app-text">
                                                                                  <p className="w-75">{t("sm_vision_p")}</p>
                                                                                </div>
                                           </Container>
                                      </div>
                                      {/* Our mission*/}
                                     <div className="whatssandwich mb-5" data-aos="fade-in" data-aos-duration="1500">
                                         <Container>
                                                                                <h4
                                                                                  className={`mb-1  ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                                >
                                                                                  {t("sm_mission")}
                                                                                </h4>
                                                                                <div className="mb-3">
                                                                                  <hr className="s-hr" />
                                                                                </div>
                                                                                <div className="app-text">
                                                                                  <p className="w-75">{t("sm_mission_p")}</p>
                                                                                </div>
                                           </Container>
                                      </div>
                                      {/* Our Core Values */}
                                      <div className="s-types mb-5" data-aos="fade-in" data-aos-duration="1500">
                                        <Container>
                                                                                   <Row>
                                                                                     <h4
                                                                                       className={`mb-1 ${
                                                                                         currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                                                                                       }`}
                                                                                     >
                                                                                       {t("corvlaue")}
                                                                                     </h4>
                                                                                     <div className="mb-3 ">
                                                                                       <hr className="s-hr" />
                                                                                     </div>
                                                                                     <Col sm={12} className="px-md-5">
                                                                                       <ul className="p-0 m-0 mb-4 list-types ">
                                                                                         <li>{t("cor1")}</li>
                                                                                         <li>{t("cor2")}</li>
                                                                                         <li>{t("cor3")}</li>
                                                                                         <li>{t("cor4")}</li>
                                                                                       </ul>
                                                                                     </Col>
                                                                                   </Row>
                                         </Container>
                                      </div>
                                      {/* Quality and Technical Standards*/}
                                     <div className="whatssandwich mb-5" data-aos="fade-in" data-aos-duration="1500">
                                         <Container>
                                                                                <h4
                                                                                  className={`mb-1  ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                                >
                                                                                  {t("qua")}
                                                                                </h4>
                                                                                <div className="mb-3">
                                                                                  <hr className="s-hr" />
                                                                                </div>
                                                                                <div className="app-text">
                                                                                  <p className="w-75">{t("qua_p")}</p>
                                                                                </div>
                                           </Container>
                                      </div>
                                      {/* Our Commitments for Standards */}
                                                                              <div className="whatssandwich mb-5" data-aos="fade-in" data-aos-duration="1500">
                                                                                <Container>
                                                                                  <h4
                                                                                    className={`mb-1  ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                                  >
                                                                                    {t("comit")}
                                                                                  </h4>
                                                                                  <div className="mb-3">
                                                                                    <hr className="s-hr" />
                                                                                  </div>
                                                                                  <div className="app-text">
                                                                                    <p className="w-75">{t("comit_p")}</p>
                                                                                  </div>
                                                                                </Container>
                                                                              </div>
              {/* circular hollow section */}
              <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                  <Container>
                                                                       <h4
                                                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                       >
                                                                         {t("chs")}
                                                                       </h4>
                                                                       <div className="mb-3">
                                                                         <hr className="s-hr" />
                                                                       </div>
                                                                       <Row>
                                                                         <table className="table table-sm text-center w-75">
                                                                           <thead>
                                                                             <tr className="table-primary">
                                                                               <th scope="col">{t("dimen")}</th>
                                                                               <th scope="col">{t("  ")}</th>
                                                                             </tr>
                                                                           </thead>
                                                                           <tbody>
                                                                             <tr>
                                                                               <td>{t("or")}</td>
                                                                               <td>{t("or1")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("sm")}</td>
                                                                               <td>{t("sm1")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("md")}</td>
                                                                               <td>{t("md1")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("lg")}</td>
                                                                               <td>{t("lg1")}</td>
                                                                             </tr>
                                                                           </tbody>
                                                                         </table>
                                                                       </Row>
                      </Container>
              </div>
              {/* square hollow section */}
              <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                  <Container>
                                                                       <h4
                                                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                       >
                                                                         {t("shs")}
                                                                       </h4>
                                                                       <div className="mb-3">
                                                                         <hr className="s-hr" />
                                                                       </div>
                                                                       <Row>
                                                                         <table className="table table-sm text-center w-75">
                                                                           <thead>
                                                                             <tr className="table-primary">
                                                                               <th scope="col">{t("dimen")}</th>
                                                                                <th scope="col">{t("  ")}</th>
                                                                             </tr>
                                                                           </thead>
                                                                           <tbody>
                                                                             <tr>
                                                                               <td>{t("or")}</td>
                                                                               <td>{t("or2")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("sm")}</td>
                                                                               <td>{t("sm2")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("md")}</td>
                                                                               <td>{t("md2")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("lg")}</td>
                                                                               <td>{t("lg2")}</td>
                                                                             </tr>
                                                                           </tbody>
                                                                         </table>
                                                                       </Row>
                      </Container>
              </div>
              {/* Rectangle hollow section */}
              <div className="s-available mb-5" data-aos="fade-in" data-aos-duration="1500">
                  <Container>
                                                                       <h4
                                                                         className={`mb-1 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}
                                                                       >
                                                                         {t("rhs")}
                                                                       </h4>
                                                                       <div className="mb-3">
                                                                         <hr className="s-hr" />
                                                                       </div>
                                                                       <Row>
                                                                         <table className="table table-sm text-center w-75">
                                                                           <thead>
                                                                             <tr className="table-primary">
                                                                               <th scope="row">{t("dimen")}</th>
                                                                               <th scope="col">{t("  ")}</th>
                                                                             </tr>
                                                                           </thead>
                                                                           <tbody>
                                                                             <tr>
                                                                               <td>{t("or")}</td>
                                                                               <td>{t("or3")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("sm")}</td>
                                                                               <td>{t("sm3")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("md")}</td>
                                                                               <td>{t("md3")}</td>
                                                                             </tr>
                                                                             <tr>
                                                                               <td>{t("lg")}</td>
                                                                               <td>{t("lg3")}</td>
                                                                             </tr>
                                                                           </tbody>
                                                                         </table>
                                                                       </Row>
                      </Container>
              </div>

              {/* Customized Length & Special Orders */}
                                      <div className="s-types mb-5" data-aos="fade-in" data-aos-duration="1500">
                                        <Container>
                                                                                   <Row>
                                                                                     <h4
                                                                                       className={`mb-1 ${
                                                                                         currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                                                                                       }`}
                                                                                     >
                                                                                       {t("cs")}
                                                                                     </h4>
                                                                                     <div className="mb-3 ">
                                                                                       <hr className="s-hr" />
                                                                                     </div>
                                                                                     <Col sm={12} className="px-md-5">
                                                                                       <ul className="p-0 m-0 mb-4 list-types ">
                                                                                         <li>{t("sl")}</li>
                                                                                         <li>{t("cl")}</li>
                                                                                       </ul>
                                                                                     </Col>
                                                                                   </Row>
                                         </Container>
                                      </div>
                                      {/*Product Applications & Use Cases*/}
                                      <div className="s-types mb-5" data-aos="fade-in" data-aos-duration="1500">
                                        <Container>
                                                                                   <Row>
                                                                                     <h4
                                                                                       className={`mb-1 ${
                                                                                         currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                                                                                       }`}
                                                                                     >
                                                                                       {t("product")}
                                                                                     </h4>
                                                                                      <div className="mb-3 ">
                                                                                       <hr className="s-hr" />
                                                                                     </div>
                                                                                     <div className="app-text">
                                                                                    <p className="w-75">{t("product_p")}</p>
                                                                                  </div>
                                                                                     <Col sm={12} className="px-md-5">
                                                                                       <ul className="p-0 m-0 mb-4 list-types ">
                                                                                         <li>{t("pro1")}</li>
                                                                                         <li>{t("pro2")}</li>
                                                                                         <li>{t("pro3")}</li>
                                                                                         <li>{t("pro4")}</li>
                                                                                         <li>{t("pro5")}</li>
                                                                                       </ul>
                                                                                     </Col>
                                                                                   </Row>
                                         </Container>
                                      </div>


              </div>
              </Container>
              </div>

 {/* CONTACT */}
      <div id="contact">
        <div className="overlay">
          <Container>
            <Row>
              <Col lg={{ span: 6, order: 2 }} className=" contactFormCol">
                <div className="contact-us">
                  <h4
                    className={`mb-4 text-center ${
                      currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                    }`}
                  >
                    {t("contact_form")}
                  </h4>
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                      <label htmlFor="name">{t("name")} :</label>
                      <input
                        type="text"
                        className="form-control form-control-sm my-1"
                        id="name"
                        placeholder={t("name")}
                        name="name"
                        required
                      />
                    </div>
                    <div className="form-group my-3">
                      <label htmlFor="email">{t("email")} :</label>
                      <input
                        type="email"
                        className="form-control form-control-sm my-1"
                        id="email"
                        placeholder={t("email")}
                        aria-describedby="emailHelp"
                        name="email"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">{t("message")} :</label>
                      <textarea
                        className="form-control form-control-sm my-1"
                        id="message"
                        placeholder={t("message")}
                        rows="3"
                        name="message"
                        required
                      ></textarea>
                    </div>
                    <div className="d-flex flex-row">
                      <Button
                        variant="primary"
                        className="mt-3 px-3 btn-sm"
                        type="submit"
                      >
                        {t("send_message")}
                      </Button>
                    </div>
                  </form>
                </div>
              </Col>
              <Col lg={{ span: 6, order: 1 }} className="text-center px-4 py-4">
                <h3
                  className={`mb-4 ${
                    currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"
                  }`}
                >
                  {t("sm_app_title")}
                </h3>
                <p className="fs-7 mb-5">
                  Al-Smood Factory was established as a pioneering industrial facility in the production of steel pipes and sections.
                </p>
                <h6>{t("address")}</h6>
                <p className="px-5">{t("sm_add_value")}</p>
                <h6>{t("phone")}</h6>
                <a href="tel:+9647704482413" className="contactLinks">
                  +964_770_448_2413
                </a>{" "}
                <br />
                <a href="tel:+9647504482413" className="contactLinks">
                  +964_750_448_413
                </a>
                 <br />
                <h6>{t("email")}</h6>
                <a href="mailto:alsmoodtubes@gamil.com" className="contactLinks">
                  alsmoodtubes@gamil.com
                </a>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div>
        <iframe
          title="runaky-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3339.890250612212!2d43.864859900000006!3d33.164508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15598b00384a0dbd%3A0xfd6c2c847374b44b!2z2YXYudmF2YQg2KfZhNi12YXZiNiv!5e0!3m2!1sen!2siq!4v1776956131965!5m2!1sen!2siq" 
          width="100%"
          height="100% "
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
      <Footer />
      <GoTop id="sm-head" />
    </>
    
    
  );
};

export default AlSmood;